export const PRODUCT_FILE_TYPES = {
  INTRO: 'intro',
  BROCHURE: 'brochure',
  ETC: 'etc'
}

export const EXTENSTION_LIST = ["gif","jpg","jpeg","png","xls","xlsx","doc","docx","ppt","pptx","pdf"]



// WEBPACK FOOTER //
// ./src/code/CodeProduct.js